import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {FormControl, FormGroup, FormsModule, ReactiveFormsModule} from '@angular/forms';
import {LoaderService} from '../../../../services/loader/loader.service';
import {UserService} from '../../../../services/user/user.service';
import {User} from '../../../../models/user';
import {SnackbarService} from '../../../../services/snackbar/snackbar.service';
import {ActivatedRoute, Router} from '@angular/router';

import {CountryService} from '../../../../services/country/country.service';
import {AuthService} from '../../../../services/auth/auth.service';
import {CopyToClipboardComponent} from '../../../layout/copy-to-clipboard/copy-to-clipboard.component';
import {MetaTitle} from '../../../../decorator/meta-title';

@Component({
  selector: 'app-current-user-form',
  imports: [
    ReactiveFormsModule,
    FormsModule,
    CopyToClipboardComponent
],
  templateUrl: './current-user-form.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './current-user-form.component.scss'
})
@MetaTitle('My account')
export class CurrentUserFormComponent implements OnInit {

  connectedUser = new User();

  form = new FormGroup({
    password: new FormControl(''),
  });

  constructor(
    private loader: LoaderService,
    private snackbar: SnackbarService,
    private router: Router,
    private route: ActivatedRoute,
    private auth: AuthService,
    private userService: UserService,
    protected countryService: CountryService,
  ) {
  }

  ngOnInit(): void {
    this.auth.getConnectedUser().subscribe((connectedUser: User) => {
      this.connectedUser = connectedUser;
    })
  }

  onSubmit(): void {
    if (!this.form.valid || !this.connectedUser.id) {
      return;
    }

    this.loader.startLoading();

    let params: any = this.form.value;

    this.userService.updateCurrent(params).subscribe(() => {
      this.loader.stopLoading();
      this.snackbar.success('Your password has been changed successfully.');
    });
  }

  randomPassword(): void {
    let password = this.generateRandomPassword();

    this.form.get('password')?.patchValue(password);
    this.form.updateValueAndValidity();
  }

  private generateRandomPassword() {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;

    let password = '';
    for (let i = 0; i < 14; ++i) {
      password += characters.charAt(Math.floor(Math.random() * charactersLength));
    }

    return password;
  }
}
